import { useRef } from "react";
import SmartLink from "./SmartLink";
import Image from "./Image";
import { useReveal } from '../hooks/UseReveal';

export default function Accreditation({ accreditation }) {

    const revealRef = useReveal({ once: true });

    return (

        <div className={`c-accreditation`}>
            <div className="c-accreditation__inner c-transition-in" ref={revealRef}> 
                {accreditation.img_src && (
                    <div className="c-accreditation__image">
                        <Image 
                            src={accreditation.img_src}
                            alt={accreditation.img_alt || ''}
                            width={366}
                            height={306}
                        />
                    </div>
                )}
                <div className="c-accreditation__content">
                    {accreditation.heading && (
                        <h3 className="c-accreditation__title c-paragraph c-paragraph--medium">{accreditation.heading}</h3>
                    )}
                    {accreditation.text && (
                        <div className="c-accreditation__text scope-text" dangerouslySetInnerHTML={{ __html: accreditation.text }} />
                    )}
                </div>
                {accreditation.url && (
                    <SmartLink link={accreditation.url} className="c-accreditation__link" />
                 )}
            </div>
        </div>
    )
}